import type { PartSvgProps } from './types'

export default function LaserSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 80,
  height = 50
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 80 50" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main compact box */}
      <rect x="8" y="8" width="64" height="34" rx="4"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Aperture circle (front, left) */}
      <circle cx="14" cy="25" r="7" fill="none" stroke={accent} strokeWidth="1.5" />
      <circle cx="14" cy="25" r="3" fill={accent} fillOpacity="0.4" stroke="none" />
      {/* Adjustment screw 1 (top) */}
      <circle cx="44" cy="10" r="4" fill="none" stroke={stroke} strokeWidth="1.2" />
      <line x1="40" y1="10" x2="48" y2="10" stroke={stroke} strokeWidth="0.8" />
      {/* Adjustment screw 2 (top, right) */}
      <circle cx="62" cy="10" r="4" fill="none" stroke={stroke} strokeWidth="1.2" />
      <line x1="58" y1="10" x2="66" y2="10" stroke={stroke} strokeWidth="0.8" />
      {/* Mount clamp bottom */}
      <rect x="14" y="42" width="52" height="6" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1" />
    </svg>
  )
}
